import CompanyContainer from "./CompanyContainer";
import CompanyStore from "./CompanyStore";

export default CompanyStore(CompanyContainer);